module.exports = __webpack_public_path__ + "static/media/use-case-3.02384c48.png";